export default __webpack_public_path__ + "static/media/plus0-5.ceda7951.png";